import React from "react";
import { Helmet } from 'react-helmet-async';

function HelmetComponent({ title, description, type,robots,imageUrl,pageUrl }) {
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={pageUrl} />
      {/* End standard metadata tags */}
      {/* Facebook tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl}/>
      <meta property="og:url" content={pageUrl}/>
      {/* End Facebook tags */}
      {/* Twitter tags */}
      <meta name="twitter:creator" content="@akerayuofficial" />
      <meta name="twitter:card" content={type} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl}/>
      {/* End Twitter tags */}
    </Helmet>
  );
}

export default HelmetComponent;
